export default __webpack_public_path__ + "static/media/secondary-tablet.87768786.png";